/** Spor Okulları — marka odaklı premium tasarım token'ları */
export const sporBrand = {
  gold: '#FFCC29',
  goldLight: '#FFE566',
  goldDark: '#C59324',
  goldMuted: 'rgba(255, 204, 41, 0.14)',
  slate: '#334155',
  slateLight: '#64748B',
  slateMuted: '#94A3B8',
  stone: '#F4F3EF',
  stoneDark: '#E8E6E1',
  white: '#FFFFFF',
  teal: '#0D9488',
  shadow: '0 1px 3px rgba(51, 65, 85, 0.06), 0 6px 20px rgba(51, 65, 85, 0.05)',
  shadowLg: '0 8px 30px rgba(51, 65, 85, 0.08)',
  radius: 12,
};

export const sporAntdTheme = {
  token: {
    colorPrimary: sporBrand.gold,
    colorPrimaryHover: sporBrand.goldLight,
    colorPrimaryActive: sporBrand.goldDark,
    colorInfo: sporBrand.teal,
    colorText: sporBrand.slateLight,
    colorTextHeading: sporBrand.slate,
    colorTextSecondary: sporBrand.slateMuted,
    colorBgContainer: sporBrand.white,
    colorBgLayout: sporBrand.stone,
    colorBorder: sporBrand.stoneDark,
    borderRadius: 10,
    borderRadiusLG: sporBrand.radius,
    fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    fontSize: 14,
    controlHeight: 42,
    boxShadow: sporBrand.shadow,
  },
  components: {
    Layout: {
      siderBg: sporBrand.white,
      bodyBg: sporBrand.stone,
    },
    Menu: {
      itemSelectedBg: sporBrand.goldMuted,
      itemSelectedColor: sporBrand.slate,
      itemHoverBg: '#FAFAF8',
      itemHoverColor: sporBrand.slate,
      itemBorderRadius: 10,
      itemHeight: 44,
      iconSize: 18,
    },
    Button: {
      primaryShadow: 'none',
      fontWeight: 600,
      borderRadius: 10,
      controlHeight: 42,
    },
    Table: {
      headerBg: '#FAFAF8',
      headerColor: sporBrand.slate,
      borderColor: sporBrand.stoneDark,
      rowHoverBg: 'rgba(255, 204, 41, 0.05)',
    },
    Card: { borderRadiusLG: sporBrand.radius },
    Modal: {
      borderRadiusLG: sporBrand.radius,
      titleFontSize: 17,
    },
    Input: { borderRadius: 10, controlHeight: 42 },
    Select: { borderRadius: 10 },
  },
};
